import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/templates/pdf/filter'; // Importing Filter component
import Table from 'views/partner/templates/pdf/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PDFView class extending JetView to create a PDF view.
 */
export default class PDFView extends JetView {
    /**
     * Configures the layout and components of the PDF view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        var vthis = this; // Reference to the current instance
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for change in selection
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                            vthis.app.callEvent('changeSize', [{}]); // Trigger change size event
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    animate: {
                        // Animation settings for pager
                        subtype: 'out',
                    },
                    size: devConfig.getDefaultDataFetch(), // Default size from configuration
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the dropdown
                    id: 'Export', // Unique identifier for the dropdown
                    width: 120, // Width of the dropdown
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Options for export format
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection change
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    // Loop through columns
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            }) // Filename with timestamp
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Format date
                                            .replace(/[\/:]/g, '_') // Replace slashes and colons
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Templates', // Append data count message
                                    ignore: {
                                        // Fields to ignore during export
                                        detailTittle: true,
                                        Action: true,
                                    },
                                });
                            } else {
                                // If PDF is selected
                                if (value == 2) {
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                }) // Filename with timestamp
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Format date
                                                .replace(/[\/:]/g, '_') // Replace slashes and colons
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Templates', // Append data count message
                                        autowidth: true, // Enable auto width for PDF
                                        ignore: {
                                            // Fields to ignore during export
                                            detailTittle: true,
                                            Action: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for left section
            rows: [Filter, Table, toolbar], // Rows containing Filter, Table, and toolbar
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                // Rows within the form
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide', // Wide type for the layout
                    cols: [left], // Columns containing the left section
                },
            ],
        };
    }

    /**
     * Initializes the PDF view and sets up event handlers.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            webix.attachEvent('onRotate', function (orientation) {
                // Event handler for screen rotation
                window.location.reload(); // Reload the page on rotation
            });
        });
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check for small screen width
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export dropdown for small screens
                $$('pagerA').define('group', 1); // Define pager group for small screens
            }
        });
    }
}

// FILE DOCUMENTED
